import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon, ClockIcon } from 'lucide-react';
import { bookingUrl, photos, treatmentCategories } from '../data/site';
export function Treatments() {
  const [activeId, setActiveId] = useState(treatmentCategories[0].id);
  const active = treatmentCategories.find(c => c.id === activeId) ?? treatmentCategories[0];
  return <section id="soins" aria-labelledby="soins-title" className="bg-cream py-20 lg:py-28" data-id="element-114" data-mp="m3j9kathmo8h">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-115" data-mp="r1chp9ecpsbe">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between" data-id="element-116" data-mp="qzrj98ox1p89">
          <h2 id="soins-title" className="font-serif text-4xl font-medium text-ink lg:text-5xl" data-id="element-117" data-mp="vtcif428wp91">
            Nos soins
          </h2>
          <div role="tablist" aria-label="Catégories de soins" className="-mx-5 flex gap-2 overflow-x-auto px-5 lg:mx-0 lg:px-0" data-id="element-118" data-mp="15r0fw1r8kauw">
            {treatmentCategories.map(c => {
            const selected = c.id === activeId;
            return <button key={c.id} role="tab" id={`tab-${c.id}`} aria-selected={selected} aria-controls={`panel-${c.id}`} onClick={() => setActiveId(c.id)} className={`whitespace-nowrap rounded-full px-5 py-2.5 text-sm font-bold transition-colors duration-150 ${selected ? 'bg-ink text-white' : 'bg-white text-muted hover:text-ink'}`} data-id="element-119" data-mp="1rqvbdgfa6l8u">
                  {c.label}
                </button>;
          })}
          </div>
        </div>

        <div className="mt-12 grid gap-12 lg:grid-cols-12" data-id="element-120" data-mp="20nm5voe6ps1b">
          <figure className="hidden lg:col-span-4 lg:block" data-id="element-121" data-mp="1vq420cf0y306">
            <img src={photos.facial} alt="Soin visage réalisé par une esthéticienne" className="sticky top-28 aspect-[4/5] w-full rounded-sm object-cover" data-id="element-122" data-mp="2t6t509fpnbb5" />
          </figure>

          <div className="lg:col-span-8" data-id="element-123" data-mp="mjbz75z5zurm">
            <AnimatePresence mode="wait" data-id="element-124" data-mp="mkdclh3nktci">
              <motion.div key={active.id} id={`panel-${active.id}`} role="tabpanel" aria-labelledby={`tab-${active.id}`} initial={{
              opacity: 0,
              y: 6
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -6
            }} transition={{
              duration: 0.18,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-125" data-mp="rg2dbnresgae">
                <p className="max-w-2xl text-lg leading-relaxed text-muted" data-id="element-126" data-mp="7tw9zufa7xe1">{active.intro}</p>
                <ul className="mt-8 divide-y divide-line border-y border-line" data-id="element-127" data-mp="3q016wvahhaiv">
                  {active.items.map(t => <li key={t.name} className="grid gap-4 py-7 sm:grid-cols-[1fr_auto] sm:items-center sm:gap-8" data-id="element-128" data-mp="3uzwzlydqdfj4">
                      <div data-id="element-129" data-mp="1o5jp8kgziykj">
                        <h3 className="font-serif text-2xl font-semibold text-ink lg:text-[28px]" data-id="element-130" data-mp="1t6zb2eqzl93z">{t.name}</h3>
                        <p className="mt-0.5 text-sm font-bold text-sage" data-id="element-131" data-mp="3dpjo460ndqgn">{t.subtitle}</p>
                        <p className="mt-2 max-w-xl leading-relaxed text-muted" data-id="element-132" data-mp="38q6pko0eyuy8">{t.description}</p>
                      </div>
                      <div className="flex items-center gap-5 sm:flex-col sm:items-end sm:gap-3" data-id="element-133" data-mp="3nf34n50w188c">
                        {t.price && <p className="flex items-baseline gap-3 whitespace-nowrap" data-id="element-134" data-mp="3ilqn1eumm1p3">
                            {t.duration && <span className="flex items-center gap-1 text-sm text-muted" data-id="element-135" data-mp="3rgogcn1orggy">
                                <ClockIcon className="h-3.5 w-3.5" aria-hidden data-id="element-136" data-mp="a8b7fphnowni" />
                                {t.duration}
                              </span>}
                            <span className="font-serif text-2xl text-ink" data-id="element-137" data-mp="2byv4tbcucb0d">{t.price}</span>
                          </p>}
                        <a href={bookingUrl} className="whitespace-nowrap rounded-full border border-ink/20 px-5 py-2 text-sm font-bold text-ink transition-colors duration-150 hover:border-sage hover:bg-sage hover:text-white" aria-label={`Réserver ${t.name}`} data-id="element-138" data-mp="271mj50shhoud">
                          {t.price ? 'Réserver' : 'Voir les tarifs'}
                        </a>
                      </div>
                    </li>)}
                </ul>
              </motion.div>
            </AnimatePresence>

            <a href="https://commeuncharme.fr/prestations" className="mt-8 inline-flex items-center gap-2 font-bold text-sage transition-colors duration-150 hover:text-sage-dark" data-id="element-139" data-mp="kbyb32deqw1s">
              Consulter la carte complète
              <ArrowRightIcon className="h-4 w-4" aria-hidden data-id="element-140" data-mp="3ssb94wth8twc" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}